import {Typography, IconButton, Tooltip} from "@mui/material"
import {Box} from "@mui/system"
import {ResponsiveRow} from "../../../constants/layout.constants"
import {formatDate, hasValidImages} from "../../../util/util"
import {GET_LISTING_IMAGE_URL} from "../../../constants/url.constants";
import {Edit, Delete, Visibility} from "@mui/icons-material"
import placeholderImage from "../../../images/building-placeholder.png"

export default function MyApplicationItem(props) {
    const getStatusColor = (status) => {
        switch (status) {
            case "PEN": return "#ff9800" // Orange for pending
            case "APP": return "#4caf50" // Green for approved
            case "REJ": return "#f44336" // Red for rejected
            default: return "#9e9e9e" // Gray for unknown
        }
    }
    const getStatusText = (applicationItem) => {
        const backendName = applicationItem?.status?.name
        if (backendName) return backendName
    }
    
    return (
        <ResponsiveRow
            sx={{
                backgroundColor: "#fff",
                width: {xs: "90%", lg: "400px"},
                height: {xs: "auto", lg: "300px"},
                borderRadius: "20px",
                padding: "20px",
                margin: "10px",
                flexDirection: "column",
                flexWrap: "nowrap",
                alignItems: "flex-start",
                position: "relative",
            }}
        >
            {/* Status Badge */}
            <ResponsiveRow
                sx={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: {xs: "flex-end", lg: "flex-start"},
                    flexWrap: "nowrap",
                    height: "40px",
                    width: "100%",
                    padding: 0,
                    marginBottom: "10px",
                }}
            >
                <Typography
                    sx={{
                        margin: "5px",
                        width: "75px",
                        textAlign: "center",
                        fontSize: ".75rem",
                        textTransform: "uppercase",
                        padding: "5px 7px",
                        borderRadius: "5px",
                        color: "#fff",
                        backgroundColor: getStatusColor(props.applicationItem.statusCd),
                        fontWeight: 600,
                    }}
                >
                    {getStatusText(props.applicationItem)}
                </Typography>
            </ResponsiveRow>
            
            {/* Property Image and Details */}
            <ResponsiveRow
                sx={{
                    flexDirection: "row",
                    alignItems: "center",
                    flexWrap: "nowrap",
                    height: "80px",
                    width: "100%",
                    padding: "10px 0",
                }}
            >
                <Box
                    component="img"
                    sx={{
                        objectFit: "cover",
                        objectPosition: "center center",
                        width: "75px",
                        height: "75px",
                        borderRadius: "10px",
                    }}
                    src={
                        hasValidImages(props.applicationItem.listing)
                            ? GET_LISTING_IMAGE_URL + "?filename=" + props.applicationItem.listing.imageFiles[0].systemFileName
                            : placeholderImage
                    }
                    alt={hasValidImages(props.applicationItem.listing) ? "Property image" : "No image available"}
                />
                <ResponsiveRow
                    sx={{
                        flexDirection: "column",
                        flexWrap: "nowrap",
                        height: "100%",
                        alignItems: "flex-start",
                        justifyContent: "center",
                        padding: "5px 20px",
                    }}
                >
                    <Typography
                        variant="h4"
                        sx={{color: "#037171", fontWeight: 700, margin: "2px 0"}}
                    >
                        {props.applicationItem.listing?.propertyName || "Property Name"}
                    </Typography>
                    <Typography variant="body2" sx={{fontWeight: 600, margin: "2px 0"}}>
                        Applied: {formatDate(props.applicationItem.dateCreated)}
                    </Typography>
                </ResponsiveRow>
            </ResponsiveRow>
            
            {/* Application Notes */}
            <ResponsiveRow
                sx={{
                    width: "100%",
                    justifyContent: "center",
                    padding: "10px 0",
                    flexWrap: "nowrap",
                }}
            >
                <Typography
                    variant="body2"
                    sx={{marginTop: "5px", width: "90%", textAlign: "start"}}
                >
                    {props.applicationItem.notes || "No additional notes provided"}
                </Typography>
            </ResponsiveRow>
            
            {/* Action Buttons - Positioned on the right */}
            <ResponsiveRow
                sx={{
                    width: "100%",
                    justifyContent: {xs: "center", lg: "flex-end"},
                    padding: "10px 0 0 0",
                    gap: "5px",
                }}
            >
                <Tooltip title="View application" arrow>
                    <IconButton
                        size="small"
                        onClick={() => props.viewApplicationItem(props.applicationItem)}
                        sx={{color: "#037171"}}
                    >
                        <Visibility fontSize="small" />
                    </IconButton>
                </Tooltip>
                {props.applicationItem.statusCd === "PEN" && (
                    <>
                        <Tooltip title="Edit application" arrow>
                            <IconButton
                                size="small"
                                onClick={() => props.editApplicationItem(props.applicationItem)}
                                sx={{color: "#ff9800"}}
                            >
                                <Edit fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete application" arrow>
                            <IconButton
                                size="small"
                                onClick={() => props.deleteApplicationItem(props.applicationItem)}
                                sx={{color: "#f44336"}}
                            >
                                <Delete fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </>
                )}
            </ResponsiveRow>
        </ResponsiveRow>
    )
}
